import { Stack, styled, Typography } from '@mui/material';

export const CompaniesStyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(7),
  marginTop: theme.spacing(6),
  textAlign: 'center',
  marginBottom: theme.spacing(16),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(15),
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(9),
  },
}));

export const StyledCompaniesHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
